import {useToast} from 'alm-react-components';
import {useTranslation} from 'react-i18next';
import {apis} from '../../services/alm';
import SaveIcon from './../../assets/images/svgicons/save.svg';
import UnSaveIcon from './../../assets/images/svgicons/unsave.svg';
import { useState, useContext } from 'react';
import PageLoader from './loader/PageLoader';
import useGaEventTracking from '../../hooks/UseGaEventTracking';
import { analytics_category, analytics_event, analytics_label } from '../../assets/constants/staticContentConstants';
import { AppContext } from '../../context/AppProvider';
interface ShareAndBookMarkProps {
  courseId: string;
  isBookmarked: boolean;
  setBookmarked: any;
  courseName:string;
}
export const ShareAndBookMark: React.FC<ShareAndBookMarkProps> = ({
  courseId,
  isBookmarked,
  setBookmarked,
  courseName
}) => {
  const {toast} = useToast();
  const {t} = useTranslation();
  const [loading, setLoading] = useState<boolean>(false);
  const {state} = useContext(AppContext);
  const gaEventTracker = useGaEventTracking();


  const bookMarkCourse = async (bookmarked: boolean) => {
    setLoading(true)
    if (bookmarked) {
      await apis.deleteBookMarkLearningObjects(courseId).then(() => {
        setBookmarked(false);
        setLoading(false);
        toast({
          description: t('Common.msgBookmarkDeleted'),
          variant: 'success',
        });
      });
    } else {
      apis.addBookMarkLearningObjects(courseId).then(() => {
        const items = {
          value: null,
          currency: null,
          transaction_id: null,
          items: [{}],
          userId:state.user?.userId,
          course_name:courseName,
          course_id:courseId
      }
    
        gaEventTracker(analytics_event.bookmarkAdded,analytics_category.buttonClickBookmarkAdded,analytics_label.bookmarkAddedLable,items);
        setBookmarked(true);
        setLoading(false);
        toast({
          description: t('Common.msgBookmarkSuccess'),
          variant: 'success',
        });
      });
    }
  };

  
   if (loading) {
     return <PageLoader />;
   }


  return (
    <div className="pb-4 flex flex-col items-end">
      <div className="flex flex-col justify-center dark:text-white">
        <div className={`flex justify-center mb-2 ${isBookmarked ? 'share-slected' : ''}`}>
          <img
            src={isBookmarked ? SaveIcon : UnSaveIcon}
            alt="No image"
            className="ms-2 cursor-pointer"
            onClick={() => bookMarkCourse(isBookmarked)}
          />
        </div>
        <div>{t('Common.bookmark')}</div>
      </div>
    </div>
  );
};
